var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "label",
      { staticClass: "btn btn-secondary", attrs: { for: "exw_file" } },
      [_vm._v(_vm._s(_vm.$t(_vm.btnLabel)))]
    ),
    _vm._v(" "),
    _c("input", {
      staticStyle: { display: "none" },
      attrs: { type: "file", id: "exw_file" },
      on: { change: _vm.onChange }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ec11bec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec11bec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/excel/WijmoExcelUpload.vue
// module id = null
// module chunks = 